export function extractMajorProjectList(payload) {
  if (Array.isArray(payload)) {
    return payload;
  }
  if (!payload || typeof payload !== "object") {
    return [];
  }
  if (Array.isArray(payload.rows)) {
    return payload.rows;
  }
  if (Array.isArray(payload.result)) {
    return payload.result;
  }
  if (Array.isArray(payload.list)) {
    return payload.list;
  }

  const data = payload.data;
  if (Array.isArray(data)) {
    return data;
  }
  if (!data || typeof data !== "object") {
    return [];
  }
  if (Array.isArray(data.rows)) {
    return data.rows;
  }
  if (Array.isArray(data.result)) {
    return data.result;
  }
  if (Array.isArray(data.list)) {
    return data.list;
  }
  return [];
}

function hasMajorProjectArray(payload) {
  if (Array.isArray(payload)) {
    return true;
  }
  if (!payload || typeof payload !== "object") {
    return false;
  }
  return (
    Array.isArray(payload.rows) ||
    Array.isArray(payload.result) ||
    Array.isArray(payload.list)
  );
}

export function shouldFallbackMajorProjectRequest(payload) {
  if (hasMajorProjectArray(payload)) {
    return false;
  }
  if (!payload || typeof payload !== "object") {
    return true;
  }

  if (
    Object.prototype.hasOwnProperty.call(payload, "success") &&
    payload.success === false
  ) {
    return true;
  }
  if (
    Object.prototype.hasOwnProperty.call(payload, "code") &&
    `${payload.code}` !== "0"
  ) {
    return true;
  }

  const data = payload.data;
  if (hasMajorProjectArray(data)) {
    return false;
  }
  if (!data || typeof data !== "object") {
    return true;
  }
  if (
    Object.prototype.hasOwnProperty.call(data, "success") &&
    data.success === false
  ) {
    return true;
  }
  if (
    Object.prototype.hasOwnProperty.call(data, "code") &&
    `${data.code}` !== "0"
  ) {
    return true;
  }
  return true;
}

export function resolveMpId2SubmitPayload(hasMpId2Config, selectedMpId2) {
  if (!hasMpId2Config) {
    return {
      shouldPersist: false,
      value: null,
    };
  }
  return {
    shouldPersist: true,
    value: selectedMpId2 || "",
  };
}

export function shouldBlockMpId2Submit(hasMpId2Config, isRequired, selectedMpId2) {
  return !!(hasMpId2Config && isRequired && !selectedMpId2);
}
